import { useState } from "react";
import {
  Box,
  Grid,
  Button,
  CircularProgress,
  Typography,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Tooltip,
  Chip,
} from "@mui/material";
import {
  ConvertDate,
  month,
} from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

import { grey, red } from "@mui/material/colors";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  GenerateExitPayrollHelper,
  GetCustomPayableExitEmployeeHelper,
} from "../../helper/PayEcms/PayEcmsRunHelper";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";

const PayrunRegularProcessedEmployee = ({tableData, isLoading, fetchData, filters,
      handleFilterChange,
      handleWorkLoacation,
      worklocationData,}) => {
  const today = new Date();
  const [payableFlag, setPayableFlag] = useState(false);
  const [payableDays, setPayableDays] = useState(0);
  const [payableDayError, setPayableDayError] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoadingbtn, setIsLoadingbtn] = useState(false);

  const handleGenerateClicked = () => {
    setIsLoadingbtn(true);
    const id = selectedRows?.map((item) => item?.employee_pk);
    GetCustomPayableExitEmployeeHelper({
      employee_fk: id?.length ? `{${id}}` : null,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setPayableDays(0);
        setPayableFlag(
          res?.data?.data?.[0]?.payroll_custom_payable_contractual_employee
        );
        setOpenDialog(true);
        setIsLoadingbtn(false);
      } else {
        setIsLoadingbtn(false);
        toast.error("Something went wrong");
      }
    });
  };
  const handleGenerate = () => {
    if (payableDays === "" || payableDays === null) {
      setPayableDayError("Payable days is required.");
      return;
    } else if (!payableDays?.toString().match(/^\d{1,2}(\.\d{1,2})?$/)) {
      setPayableDayError("Invalid payable days.");
      return;
    } else {
      setPayableDayError("");
    }
    setIsLoadingbtn(true);
    const current_month = String(today.getMonth() + 1);
    const current_year = String(today.getFullYear());
    const id = selectedRows?.map((item) => item.employee_pk);
    GenerateExitPayrollHelper({
      employee_fk: id?.length ? `{${id}}` : `{}`,
      month: current_month,
      year: current_year,
      custom_payable_days: payableDays,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        fetchData();
        setSelectedRows([]);
      }
      setIsLoadingbtn(false);
    });
    setOpenDialog(false);
  };

  const tableTitle = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Processed Employee
      </Typography>
    </Box>
  );
  const handleSelect = (rows) => {
    setSelectedRows(rows);
  };
  return (
    <Box mt={2}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          pr: 2,
          mb: 1,
        }}
      >
          <Tooltip
            title={
              tableData?.length === 0 ? "" : selectedRows?.length === 0
                ? "Select employee to regenerate payroll"
                : ""
            }
            arrow
          >
            <Box>
              <Button
                onClick={handleGenerateClicked}
                className="mpl-primary-btn"
                disabled={selectedRows?.length === 0 || tableData?.length === 0 || isLoadingbtn}
                startIcon={
                  isLoadingbtn ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                {"Regenerate Payroll"}
              </Button>
            </Box>
          </Tooltip>

      </Box>
      <Box>
        <MaterialTable
          isLoading={isLoading}
          columns={[
            {
              title: "Employee Name",
              headerStyle: {
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
              field: "employee_name",
            },
             {
                title: "Work Location",
                field: "work_location_name",
                headerStyle: {
                padding: "0px 0px 0px 5px",
                textAlign: "start",
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "0px 0px 0px 5px",
                },
                render: (rowData) => rowData?.work_location_name || "N/A"
            },
            {
              title: "DOJ",
              field: "doj",
              align: "center",
              headerStyle: {
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
              render: (rowData) => ConvertDate(rowData?.doj),
            },
            {
              title: "Resignation Date",
              field: "resignation_date",
              headerStyle: {
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 7px",
              },
              render: (rowData) => ConvertDate(rowData?.resignation_date),
            },
            {
              title: "Last Working Date",
              field: "lwd",
              headerStyle: {
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 7px",
              },
              render: (rowData) => ConvertDate(rowData?.lwd),
            },
            {
              title: "Month-Year",
              field: "lwd",
              headerStyle: {
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 7px",
              },
              render: (rowData) => rowData?.month ? `${month[+rowData?.month - 1]}-${rowData?.year}` : "—",
            },
            {
              title: "Status",
              field: "status",
              headerStyle: {
                padding: "0px 0px 0px 13px",
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 0px",
              },
              render: (rowData) => {
                const { bg, text } = getStatusColor(
                  rowData?.status
                );
                return (
                  <Box sx={{ textAlign: "start", pl: "10px" }}>
                    <Chip
                      label={rowData?.status}
                      style={{
                        backgroundColor: bg,
                        color: text,
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                  </Box>
                );
              },
            },
          ]}
          data={tableData || []}
          options={{
            maxBodyHeight: 320,
            minBodyHeight: 320,
            maxWidth: "80vh",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "5px 0px 5px 0px", fontWeight: "bold" },
            cellStyle: { height: "35px" },
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            selection: true,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
            showTitle: true,
          }}
          onSelectionChange={handleSelect}
          title={""}
          components={{
          Toolbar: (props) => (
              <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                  <Box
                      sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#f3edfd",
                      padding: "0px 0px 0px 20px",
                      flexGrow: 1,
                      minHeight: "48px !important",
                      }}
                  >
                  <Box>
                      <Typography variant='h6'>
                          {tableTitle}
                      </Typography>
                  </Box>
                  <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                      <SelectableMultiSelect
                          multiple
                          label="Work Location"
                          placeholder="Select Location"
                          value={filters?.ats_work_location_id}
                          loading={handleWorkLoacation}
                          fieldLabel="work_location_name"
                          name="ats_work_location_id"
                          size="small"
                          onChangeEvent={handleFilterChange}
                          data={worklocationData}
                          menuHeight={150} // optional
                      />
                  </Box> 
                  </Box>
                  <Box
                      sx={{
                          "& .MuiToolbar-root": {
                          padding: "14px 16px !important",
                          margin: "auto !important",
                          minHeight: "48px !important",
                          },
                          "& .MuiFormControl-root": {
                          margin: "0 !important",
                          },
                          "& .MuiInputBase-root": {
                          marginLeft: "-20px !important",
                          }
                      }}
                      >
                          <MTableToolbar {...props} />
                      </Box>
                  </Box>
          ),
        }}
        />
      </Box>

      {/* Generate payroll confirmation dialog */}
      <Dialog open={openDialog} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Regenerate Payroll
          <IconButton onClick={() => setOpenDialog(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{ fontWeight: 600, color: "inherit" }}
              >
                {`Payroll will be regenerated for these employees. Are you sure you want to continue?`}
              </Typography>
            </Grid>
            {payableFlag && (
              <Grid key="payday" item xs={12}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1.5, color: "text.secondary" }}
                >
                  Some employees is configured with the Payable Days template.
                  Please enter the number of payable days to calculate salary.
                </Typography>
                <FormControl fullWidth>
                  <TextField
                    autoFocus
                    size="small"
                    value={payableDays}
                    onChange={(e) => {
                      setPayableDays(e.target.value);
                      setPayableDayError("");
                    }}
                    variant="outlined"
                    required
                    label="Payable Days"
                    name="custom_payable_days"
                    type="number"
                    placeholder="00.00"
                    sx={{
                      "& input::placeholder": {
                        color: "#B0B0B0",
                      },
                    }}
                    {...(payableDayError && {
                      error: true,
                      helperText: payableDayError,
                    })}
                  />
                </FormControl>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Box
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={() => setOpenDialog(false)}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleGenerate}
              sx={{
                ":hover": { color: grey[50], background: red[700] },
                color: grey[50],
                background: red[500],
              }}
            >
              Yes
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
    case "Action Needed":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
    case "Self Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
export default PayrunRegularProcessedEmployee;
